import axios from "axios";
import { getApiUrl } from './api';

export const getRedirectFromToken = (token) => {
    return axios.get(`${getApiUrl()}/external/${token}`).then((response) => {
        return response.data;
    });
}